import { getFileName, getFileType } from "src/utils/common";
import { FORM_NAME } from "src/pages/TestPackage/detail";
import { ButtonDownload } from "src/components/Common/Button";
import ProtectedComponent from "src/components/Permission";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

export const columns = ({ t }) => [
  {
    dataField: `${FORM_NAME.FILES_HISTORY.UPDATED_AT}`,
    text: t(`detail.${FORM_NAME.FILES_HISTORY.UPDATED_AT}`),
    headerClass: "width-by-px-80 text-nowrap",
  },
  {
    dataField: "",
    text: t(`detail.${FORM_NAME.FILES_HISTORY.TYPE}`),
    headerClass: "width-by-px-50 text-nowrap",
    formatter: (_, row) => <span className="text-uppercase">{getFileType(row?.[FORM_NAME.FILES_HISTORY.TYPE])}</span>,
  },
  {
    dataField: `${FORM_NAME.FILES_HISTORY.NAME}`,
    text: t(`detail.file_history.${FORM_NAME.FILES_HISTORY.NAME}`),
    headerClass: "width-by-px-224 text-nowrap",
    formatter: (_, row) => {
      const fileName = getFileName(row?.[FORM_NAME.FILES_HISTORY.NAME]);
      return (
        <TooltipWrapper
          id={`tooltip-filename-${row?.id}`}
          tooltipText={fileName || ""}
          checkOverflow={true}
          tooltipClassName="max-width-by-px-300"
        >
          <p className="mb-0 max-width-by-px-224 min-width-by-px-80 overflow-hidden text-truncate">{fileName || ""}</p>
        </TooltipWrapper>
      );
    },
  },
  {
    dataField: `${FORM_NAME.FILES_HISTORY.SOURCE}`,
    text: t(`detail.${FORM_NAME.FILES_HISTORY.SOURCE}`),
    headerClass: "width-by-px-120 text-nowrap",
  },
  {
    dataField: "",
    text: t(`detail.file_history.${FORM_NAME.FILES_HISTORY.CHANGED_BY}`),
    headerClass: "width-by-px-160 text-nowrap",
    formatter: (_, row) => {
      const name = row?.user_updated_by?.[FORM_NAME.FILES_HISTORY.CHANGED_BY] || row?.updated_by || "";
      return (
        <TooltipWrapper id={`tooltip-changed-by-${row?.id}`} tooltipText={name} checkOverflow={true} tooltipClassName="max-width-by-px-300">
          <p className="mb-0 max-width-by-px-224 min-width-by-px-80 overflow-hidden text-truncate">{name}</p>
        </TooltipWrapper>
      );
    },
  },
  {
    dataField: "",
    text: t("detail.action"),
    headerClass: "width-by-px-60 text-nowrap",
    formatter: (_, row) => {
      return (
        <div className="d-flex justify-content-center align-items-center">
          <ProtectedComponent id={`test_package_download_${row?.id}`}>
            <ButtonDownload url={row?.s3_url} id={row?.id} handleDownload={() => window.open(row?.s3_url, "_blank")} />
          </ProtectedComponent>
        </div>
      );
    },
  },
];
